import { UserIdSchema as i, PaymentTransactionIdSchema as t, DateTimeSchema as r, PayoutIdSchema as c } from "@hprofits/shared";
import { z as e } from "zod";
import { createCreationResultSchema as p } from "../common/creation-result.js";
import { PaginationSchema as s, ApiSortModeSchema as l, paginatedList as d } from "../common/pagination.js";
import { idListQueryParam as u } from "../common/params.js";
const o = 100, R = e.object({
  id: i,
  firstName: e.string(),
  lastName: e.string(),
  email: e.string(),
  isEmailVerified: e.boolean(),
  messenger: e.string().nullable(),
  messengerId: e.string().nullable(),
  isSubscribed: e.boolean(),
  balanceAlerts: e.boolean()
}).readonly(), U = e.object({
  firstName: e.string().trim().min(1).max(o),
  lastName: e.string().trim().min(1).max(o),
  messengerId: e.string().trim().max(o).nullable(),
  isSubscribed: e.boolean(),
  balanceAlerts: e.boolean()
}).strict().readonly(), y = 100, b = 25, A = 2, S = e.enum(["id", "createdAt", "approvedAt", "amount"]), v = s.extend({
  pageSize: e.coerce.number().int().min(1).max(y).default(b),
  sortBy: S.default("id"),
  sortDirection: l.default("desc"),
  ids: u(t).optional()
}).readonly(), h = e.object({
  id: t,
  createdAt: r.nullable(),
  approvedAt: r.nullable(),
  /** Whole US dollars. */
  amount: e.number(),
  invoiceId: e.int().positive().nullable(),
  failed: e.boolean()
}).readonly(), B = d(h), g = e.enum(["id", "periodFrom", "paymentDate", "amount"]), D = s.extend({
  pageSize: e.coerce.number().int().min(1).max(y).default(b),
  sortBy: g.default("id"),
  sortDirection: l.default("desc"),
  ids: u(c).optional()
}).readonly(), P = e.object({
  id: c,
  periodFrom: e.iso.date().nullable(),
  periodTo: e.iso.date().nullable(),
  paymentDate: e.iso.date().nullable(),
  amount: e.number(),
  invoiceId: e.int().positive().nullable()
}).readonly(), O = d(P), Y = e.object({
  paymentId: e.coerce.number().pipe(t)
}).readonly(), z = e.object({
  payoutId: e.coerce.number().pipe(c)
}).readonly(), L = 50, m = 1e5, G = 34, F = e.object({
  amount: e.int().min(-m).max(m).refine((n) => n !== 0, { error: "Amount cannot be zero" })
}).readonly(), X = p(t), f = e.object({
  id: i,
  firstName: e.string(),
  lastName: e.string(),
  email: e.string()
}).readonly(), q = f.nullable(), N = e.object({
  /** US dollars; negative once the spend exceeds the payments. */
  amount: e.number(),
  currency: e.literal("USD")
}).readonly(), Q = N.nullable(), T = e.string().trim().toUpperCase().length(A), a = e.string().trim().min(1), C = e.object({
  code: e.string(),
  name: e.string()
}).readonly(), H = e.array(C).readonly(), I = e.object({
  countryCode: e.string().nullable(),
  city: e.string(),
  streetAddress: e.string(),
  zipCode: e.string(),
  isCompany: e.boolean(),
  companyName: e.string().nullable(),
  vatTaxId: e.string().nullable()
}).readonly(), V = I.nullable(), Z = e.object({
  countryCode: T,
  city: a,
  streetAddress: a,
  zipCode: a,
  isCompany: e.boolean(),
  companyName: a.nullable(),
  vatTaxId: a.nullable()
}).refine((n) => !n.isCompany || n.companyName !== null, {
  path: ["companyName"],
  error: "Company name is required for a company"
}).refine((n) => !n.isCompany || n.vatTaxId !== null, {
  path: ["vatTaxId"],
  error: "VAT number is required for a company"
}).readonly();
export {
  y as ACCOUNT_PAYMENTS_MAX_PAGE_SIZE,
  m as ACCOUNT_PAYMENT_MAX_AMOUNT,
  L as ACCOUNT_PAYMENT_MIN_AMOUNT,
  Q as AccountBalanceResponseSchema,
  N as AccountBalanceSchema,
  q as AccountManagerResponseSchema,
  f as AccountManagerSchema,
  Y as AccountPaymentIdParamSchema,
  h as AccountPaymentSchema,
  v as AccountPaymentsQuerySchema,
  B as AccountPaymentsResponseSchema,
  S as AccountPaymentsSortBySchema,
  z as AccountPayoutIdParamSchema,
  P as AccountPayoutSchema,
  D as AccountPayoutsQuerySchema,
  O as AccountPayoutsResponseSchema,
  g as AccountPayoutsSortBySchema,
  R as AccountProfileSchema,
  H as BillingCountriesResponseSchema,
  C as BillingCountrySchema,
  X as CreateAccountPaymentResultSchema,
  F as CreateAccountPaymentSchema,
  G as PAYMENT_BYPASS_MIN_GRANT,
  V as PaymentInformationResponseSchema,
  I as PaymentInformationSchema,
  U as UpdateAccountProfileSchema,
  Z as UpdatePaymentInformationSchema
};
//# sourceMappingURL=schemas.js.map
